






import { Component, Vue } from 'vue-property-decorator';
import RoundBoard from '@/components/RoundBoard.vue'; // @ is an alias to /src

@Component({
  components: {
    RoundBoard,
  },
})
export default class Home extends Vue {}
